import MessagingChannelHeader from './MessagingChannelHeader';

export default MessagingChannelHeader;
